/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { config } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faPlay, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import 'moment-duration-format';
import request from 'request';
import _ from 'lodash';

config.autoAddCss = false;

function formatCreationDate(date) {
  return moment(date).format('DD/MM/YYYY HH:mm');
}

function formatVideoDuration(duration) {
  return moment.duration(duration, 'seconds').format('mm:ss', { trim: false });
}

function fomatImageSize(size) {
  let imageSizeInKBytes = size / 1000;
  if (imageSizeInKBytes > 1000) {
    // show it MB
    imageSizeInKBytes /= 1000;
    return `${(Math.round(imageSizeInKBytes * 10) / 10)}MB`;
  }
  return `${(Math.round(imageSizeInKBytes * 100) / 100)}KB`;
}

function showSessionData(projectId, sessionId, settingsId) {
  const { location: { origin } } = window;
  const url = `${origin}/api/session-data?project=${projectId}&session=${sessionId}&settings=${settingsId}`;
  request(
    url,
    { json: true },
    (error, resp, body) => {
      if (error) {
        alert('Something went wrong!');
        console.log(error);
      } else {
        const { statusCode } = resp;
        if (statusCode === 200) {
          alert(_.isEmpty(body)
            ? 'No session data found'
            : _.reduce(body, (acc, v, k) => `${acc}\n• ${k}: ${v}`, 'Session data:'));
        } else {
          alert(body.message);
        }
      }
    },
  );
}

class GalleryItem extends Component {
  constructor(props) {
    super(props);

    this.onVideoClick = this.onVideoClick.bind(this);
    this.toggleExtraInfo = this.toggleExtraInfo.bind(this);
    this.toggleExtraInfoOnHover = this.toggleExtraInfoOnHover.bind(this);
    this.resetInfoStates = this.resetInfoStates.bind(this);

    this.state = {
      extraInfoDisplayed: false,
      infoButtonHovered: false,
      infoButtonClicked: false,
    };
  }

  onVideoClick() {
    const { video } = this.props.videoInfo;
    if (video !== undefined) {
      this.props.onVideoPlay(video.blob.url, video);
    }
  }

  toggleExtraInfo() {
    this.setState({
      extraInfoDisplayed: !this.state.infoButtonClicked,
      infoButtonClicked: !this.state.infoButtonClicked,
    });
  }

  toggleExtraInfoOnHover() {
    if (!this.state.infoButtonClicked) {
      this.setState({
        extraInfoDisplayed: !this.state.infoButtonHovered,
        infoButtonHovered: !this.state.infoButtonHovered,
      });
    }
  }

  resetInfoStates() {
    this.setState({
      extraInfoDisplayed: false,
      infoButtonHovered: false,
      infoButtonClicked: false,
    });
  }

  renderExtraInfo() {
    const showClass = this.state.extraInfoDisplayed ? 'show' : '';
    if (this.props.videoInfo.video) {
      return (
        <div
          className={`extra-info ${showClass}`}
        >
          <div className="videoDetailsLine">
            <span className="videoDetailsLabel">Resolution: </span>
            <span>{
              `${this.props.videoInfo.video.width} x` +
              ` ${this.props.videoInfo.video.height}`
            }
            </span>
          </div>
          <div className="videoDetailsLine">
            <span className="videoDetailsLabel">Size: </span>
            <span>
              { fomatImageSize(this.props.videoInfo.video.blob.size) }
            </span>
          </div>
        </div>
      );
    }
    return (
      <div
        className={`extra-info ${showClass} not-ready`}
      >
        <div className="videoDetailsLine">
          <div className="video-not-ready-notification">Video not ready yet</div>
        </div>
      </div>
    );
  }

  render() {
    const infoButtonNotReadyClass = this.props.videoInfo.video ? '' : 'not-ready';
    return (
      <div className="col-12 col-sm-6 col-lg-4 gallery-item-container">
        <div className="galleryItem">
          <div className="imgContainer" onMouseOver={this.resetInfoStates}>

            { this.props.videoInfo.thumb ?
              <div
                className="video-gallery-thumb flex-embed"
                style={{ backgroundImage: `url(${this.props.videoInfo.thumb.blob.url})` }}
              />
              :
              <div
                className="video-gallery-thumb flex-embed"
              />
            }
            { this.props.videoInfo.video ?
              <div className="video-duration">
                { formatVideoDuration(this.props.videoInfo.video.duration) }
              </div>
              :
              <span />
            }

            { this.renderExtraInfo() }

            { this.props.videoInfo.thumb ?
              <div
                role="button"
                tabIndex={0}
                className="imgWrapper"
                onClick={this.onVideoClick}
              >
                {/* <div className="play-indicator" /> */}
                <FA icon={faPlay} color="#ffffff" fixedWidth size="lg" className="play-indicator" />
              </div>
              :
              <FA icon={faExclamationCircle} color="#89949B" fixedWidth size="lg" className="video-not-ready-icon" />
            }

          </div>

          <div className="videoDetails">
            <div className="row videoDetailsLine">
              <div className="col-6">
                <span>{ formatCreationDate(this.props.videoInfo.createdAt) }</span>
              </div>
              <div className="col-6">
                <div className="video-buttons-container float-right">
                  {this.props.passwordProtected && (
                    <button
                      className="video-btn session-data"
                      onClick={() => showSessionData(this.props.projectId, this.props.videoInfo.session, this.props.videoInfo.settings)}
                    />
                  )}
                  <button
                    className={`video-btn info ${infoButtonNotReadyClass}`}
                    onClick={this.toggleExtraInfo}
                    onMouseOver={this.toggleExtraInfoOnHover}
                    onMouseOut={this.toggleExtraInfoOnHover}
                  />
                  { this.props.videoInfo.video ?
                    <a
                      className="video-btn download"
                      href={this.props.videoInfo.video !== undefined ?
                        this.props.videoInfo.video.blob.url : ''
                      }
                      download="videoFile.mp4"
                    >&nbsp;
                    </a>
                    :
                    <span className="video-btn download disabled" />
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

GalleryItem.propTypes = {
  projectId: PropTypes.string.isRequired,
  passwordProtected: PropTypes.bool.isRequired,
  videoInfo: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  onVideoPlay: PropTypes.func.isRequired,
};

export default GalleryItem;



// WEBPACK FOOTER //
// ./src/client/components/gallery/GalleryItem.js